/* eslint-disable react/display-name */
import React from "react";

import AdGroupSelectionSlide from "../../views/CampaignCreationBasicSlides/AdGroupSelectionSlide";
import AdvertiserSelectionSlide from "../../views/CampaignCreationBasicSlides/AdvertiserSelectionSlide";
// import CRMRetargetinSegmentsPage from "../CRMRetargetingSegmentsPage";
import CampaignBasicDetailsSlide from "../../views/CampaignCreationBasicSlides/CampaignBasicDetailsSlide";
import CampaignSummarySlide from "../../views/CampaignCreationBasicSlides/CampaignSummarySlide";
import LandingPageSelectionSlide from "../../views/CampaignCreationBasicSlides/LandingPageSelectionSlide";
import RoleTitleSelectionSlide from "../../views/CampaignCreationBasicSlides/RoleTitleSelectionSlide";
import SelectHubspotTargetCompaniesSlide from "../../views/CampaignCreationBasicSlides/SelectHubspotTargetCompaniesSlide";
import { BaseStep, BaseStepComponentProps } from "../../components/modules/BaseStepper/BaseStepper";
import { CAMPAIGN_STEPS } from "../../types/campaignTypes";

export const steps: BaseStep[] = [
  {
    label: "Select Advertiser",
    stepComponent: (props: BaseStepComponentProps) => <AdvertiserSelectionSlide {...props} />,
    name: CAMPAIGN_STEPS.SELECT_ADVERTISER,
  },
  {
    label: "Campaign Details",
    stepComponent: (props: BaseStepComponentProps) => <CampaignBasicDetailsSlide {...props} />,
    name: CAMPAIGN_STEPS.CAMPAIGN_DETAILS,
  },
  {
    label: "Target Companies",
    stepComponent: (props: BaseStepComponentProps) => <SelectHubspotTargetCompaniesSlide {...props} />,
    name: CAMPAIGN_STEPS.TARGET_COMPANIES,
  },
  // CRM Re-targeting Segments disabled for now
  // {
  //   label: "CRM Re-targeting Segments",
  //   stepComponent: (props: BaseStepComponentProps) => <CRMRetargetinSegmentsPage {...props} />,
  //   name: CAMPAIGN_STEPS.CRM_RETARGETING_SEGMENTS,
  // },
  {
    label: "Role/Title",
    stepComponent: (props: BaseStepComponentProps) => <RoleTitleSelectionSlide {...props} />,
    name: CAMPAIGN_STEPS.ROLE_TITLES,
  },
  {
    label: "Landing Page",
    stepComponent: (props: BaseStepComponentProps) => <LandingPageSelectionSlide {...props} />,
    name: CAMPAIGN_STEPS.LANDING_PAGE,
  },
  {
    label: "Ad Group",
    stepComponent: (props: BaseStepComponentProps) => <AdGroupSelectionSlide {...props} />,
    name: CAMPAIGN_STEPS.AD_GROUP_PAGE,
  },
  {
    label: "Summary",
    stepComponent: (props: BaseStepComponentProps) => <CampaignSummarySlide {...props} />,
    name: CAMPAIGN_STEPS.SUMMURY_PAGE,
  },
];
